import {
  DAYS,
  OPEN_STATUSES,
  REQUEST_STATUSES,
  REQUEST_TYPES,
} from "../ludConnect.constants";

export const defaultHours = (open = "12:00م", close = "12:00ص") => {
  const hours = {};
  DAYS.forEach((day) => {
    hours[day.id] = `${open} – ${close}`;
  });
  return hours;
};

export const fmtDate = (value, ar = true) => {
  const date = new Date(value);
  const locale = ar ? "ar-SA-u-nu-latn" : "en-GB";
  return `${date.toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" })} — ${date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })}`;
};

export const fmtDateShort = (value, ar = true) => {
  if (!value) return "";
  return new Date(value).toLocaleDateString(ar ? "ar-SA-u-nu-latn" : "en-GB", {
    day: "2-digit",
    month: "2-digit",
  });
};

export const statusInfo = (id, ar = true) => {
  const status = REQUEST_STATUSES.find((item) => item.id === id);
  return status
    ? { ...status, label: ar ? status.label : status.labelEn }
    : { id, label: id, final: false };
};

export const requestTypeInfo = (id, ar = true) => {
  const type = REQUEST_TYPES[id];
  return type
    ? { ...type, label: ar ? type.label : type.labelEn }
    : { label: id, icon: "issue", cat: "edit" };
};

export const elapsedInfo = (request, ar = true) => {
  const end =
    request.status === "done" && request.doneAt
      ? new Date(request.doneAt)
      : new Date();
  const start = new Date(request.createdAt);
  const hours = (end - start) / 3600000;

  if (["done", "rejected"].includes(request.status)) {
    const duration =
      hours < 24
        ? `${Math.max(1, Math.round(hours))} ${ar ? "ساعة" : "hours"}`
        : `${Math.max(1, Math.round(hours / 24))} ${ar ? "يوم" : "days"}`;
    return { className: "done", text: `${ar ? "استغرق" : "Took"} ${duration}` };
  }

  let text;
  if (hours < 1) text = ar ? "منذ دقائق" : "Minutes ago";
  else if (hours < 24)
    text = ar
      ? `منذ ${Math.floor(hours)} ساعة`
      : `${Math.floor(hours)} hours ago`;
  else
    text = ar
      ? `منذ ${Math.floor(hours / 24)} يوم`
      : `${Math.floor(hours / 24)} days ago`;

  if (hours < 6) return { className: "fresh", text };
  if (hours < 24) return { className: "warn", text };
  return { className: "late", text };
};

export const merchantAlertInfo = (restaurant, requests) => {
  const visible = requests.filter(
    (request) =>
      !request.deleted &&
      (request.storeCode === restaurant.id || request.payload.restId === restaurant.id) &&
      request.status !== "draft" &&
      OPEN_STATUSES.includes(request.status),
  );
  return {
    count: visible.length,
    hasNewReg: visible.some(
      (request) => REQUEST_TYPES[request.type]?.cat === "link",
    ),
    hasEdit: visible.some(
      (request) => REQUEST_TYPES[request.type]?.cat === "edit",
    ),
    hasIssue: visible.some((request) => request.type === "issue"),
  };
};
